import type { Action } from 'react-sweet-state';
import type { State } from '../types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default <T extends State>(key: string, ...args: unknown[]): Action<T> =>
	({ getState }): void =>
		// @ts-expect-error - TS2339 - Property 'forEach' does not exist on type 'Set<unknown> | T[string]'. | TS7006 - Parameter 'cb' implicitly has an 'any' type.
		(getState()[key] || new Set()).forEach((cb) => cb(...args));
